module.exports = __webpack_public_path__ + "img/solution_institutionalcare.db6390d9.png";